import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const severityStyles = {
  success: {
    color: "#047857",
    border: "#a7f3d0",
    background: "#f0fdf4",
    icon: <CheckCircleIcon fontSize="small" />,
  },
  error: {
    color: "#b91c1c",
    border: "#fecaca",
    background: "#fff1f2",
    icon: <ErrorIcon fontSize="small" />,
  },
  warning: {
    color: "#b45309",
    border: "#fde68a",
    background: "#fffbeb",
    icon: <WarningAmberIcon fontSize="small" />,
  },
  info: {
    color: "#1d4ed8",
    border: "#bfdbfe",
    background: "#eff6ff",
    icon: <InfoOutlinedIcon fontSize="small" />,
  },
};

export default function Notification({ open, message, severity = "info", onClose, ...props }) {
  const style = severityStyles[severity] ?? severityStyles.info;

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{
        top: { xs: 16, sm: 24 },
        left: { xs: 12, sm: "50%" },
        right: { xs: 12, sm: "auto" },
        width: { xs: "auto", sm: "min(520px, calc(100vw - 48px))" },
      }}
      {...props}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        icon={style.icon}
        variant="outlined"
        sx={{
          width: "100%",
          alignItems: "center",
          borderRadius: "8px",
          borderColor: style.border,
          backgroundColor: style.background,
          boxShadow: "0 18px 44px rgba(15, 23, 42, 0.16)",
          color: style.color,
          fontFamily: "Poppins, sans-serif",
          fontWeight: 700,
          fontSize: { xs: 13, sm: 14 },
          lineHeight: 1.45,
          px: { xs: 1.5, sm: 2 },
          py: 1.25,
          "& .MuiAlert-icon": {
            color: style.color,
            mr: 1.25,
          },
          "& .MuiAlert-message": {
            width: "100%",
            padding: 0,
          },
          "& .MuiAlert-action": {
            alignItems: "center",
            padding: 0,
            marginRight: 0,
            marginLeft: 1,
            "& .MuiIconButton-root": {
              color: style.color,
              padding: "4px",
            },
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
